import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { FormattedMessage } from 'react-intl';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../_helpers/_methods';

export default function FrontStatModule() {
  const [FrontBrandData, setFrontBrandData] = useState({});
  useEffect(() => {
    const getFrontBrandData = async () => {
      try {
        let response = await fetchWrapper.get('/dashboard');
        setFrontBrandData(response.data);
      } catch (error) {
        ErrorMessageHandler(error);
      }
    };
    getFrontBrandData();
  }, []);

  return (
    <section className="py-8 pt-md-11 pb-md-6">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card-group card-border card-border-lg border-primary shadow-light-lg">
              <div className="card">
                <div className="card-body">
                  <h2 className="fw-bold text-center mb-0">
                    <CountUp start={0} end={Math.floor(FrontBrandData.participants / 1000)} />
                    K+
                  </h2>
                  <p className="text-center text-muted mb-0">
                    <FormattedMessage id="front.stat.participant" />
                  </p>
                </div>
              </div>
              <div className="card border-start-md">
                <div className="card-body">
                  <h2 className="fw-bold text-center mb-0">
                    <CountUp start={0} end={FrontBrandData.total_events} />
                  </h2>
                  <p className="text-center text-muted mb-0">
                    <FormattedMessage id="front.stat.event" />
                  </p>
                </div>
              </div>
              <div className="card border-start-md">
                <div className="card-body">
                  <h2 className="fw-bold text-center mb-0">
                    <CountUp start={0} end={FrontBrandData.resource_person} />
                  </h2>
                  <p className="text-center text-muted mb-0">
                    <FormattedMessage id="front.stat.rp" />
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* <p className="text-end text-muted mt-3">___ Fi.Yr 2077/78</p> */}
        </div>
      </div>
    </section>
  );
}
